import { h } from "preact";

import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex" alignItems="center">
      <CircularProgress variant="determinate" color="primary" value={props.mode === "count" ? (props.num * 100) / props.tot : props.value} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
        //style="height: 40px;"
      >
        {props.mode && props.mode === "count" ? (
          <Typography variant="caption" component="div">
            {props.num}/{props.tot}
          </Typography>
        ) : (
          <Typography variant="caption" component="div" xss>{`${Math.round(props.value)}%`}</Typography>
        )}
      </Box>
    </Box>
  );
}

// CircularProgressWithLabel.propTypes = {
//   /**
//    * The value of the progress indicator for the determinate variant.
//    * Value between 0 and 100.
//    */
//   value: PropTypes.number.isRequired,
// };

// export default function CircularStatic() {
//   const [progress, setProgress] = useState(10);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
//     }, 800);
//     return () => {
//       clearInterval(timer);
//     };
//   }, []);

//   return <CircularProgressWithLabel value={progress} />;
// }
